import React, { useEffect, useState } from 'react';
import { Tabs, Popover, Tooltip, Row,Col } from 'antd';
import { ReactComponent as InfoIcon } from 'assets/icons/info_icon.svg';
import { ReactComponent as Check } from 'assets/icons/check.svg';
import { getLocalString, localNames } from "utils/localisation.service";
import { useSelector, useDispatch } from 'react-redux';
import ApplicationStatusOverview from 'components/applicationStatusOverview';
import {ReactComponent as ViewTaskLink} from '../../assets/icons/view_task_link.gov.svg';
import { useNavigate } from 'react-router-dom';
import { claimActiveViewMode, updateFormField } from "store/forms/actions";

const { TabPane } = Tabs;

const CustomTabsTimeline = ({ tabs, tabProps, customClass, current, setCurrent, activeTask, isApptrack, ...rest }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locales = useSelector(state => state.forms?.localeStrings);
  const [activeTab, setActiveTab] = useState(current);
  const activeFormId = useSelector(state=>state.activeForm.activeFormId);
  const activeTaskId = useSelector(state=>state.appTrack.apptrackDetails?.activeTaskId);
  const activeTaskName = useSelector(state => state.forms?.activeTaskName);
  const businessKey = useSelector(state => state.forms?.businessKey);
  
  const onViewMode = () => {
    window.open(`/go-beyond/main-forms/${activeTaskId}/view`, '_blank');
  }

  const onChange = key => {
    setActiveTab(Number(key));  // Ensure key is treated as a number
    setCurrent(Number(key));  // Update the parent component
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'currentSubTab',
        value: 0,
      })
    );
  };

  useEffect(() => {
    setActiveTab(current);
  }, [current]);

  return (
    <div className={`${customClass}`}>
      <Tabs
        defaultActiveKey={activeTab.toString()}  // Convert to string
        activeKey={activeTab.toString()}  // Convert to string
        onChange={onChange}
        {...rest}
      >
        {tabs.map(({ name, label, Component, subtabs }, index) => (
          <TabPane 
            key={index} 
            tab={
              <div className='tab-timeline'>
                <div className={`ml-1 tab-timeline-index`}> 
                  {activeTab > index ? <Check className={`tab-timeline-check`} width={'14px'} height={'14px'} /> : index + 1}
                </div>
                <div className='tab-timeline-label'>
                  {/* {name === "AREAFORM" ? getLocalString(locales, localNames.REQUEST_PAGE_AREA_FORM) :
                    name === "RECEIPT" ? getLocalString(locales, localNames.REQUEST_PAGE_RECEIPT) :
                    name === "OUTPUTLINE" ? getLocalString(locales, localNames.REQUEST_PAGE_OUTPUTLINE) : 
                    name === "DOCUMENTS" ? getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS) : 
                    getLocalString(locales, localNames.REQUEST_PAGE_HISTORICITY)} */}
                    {name === "AREAFORM" ? 'Περιοχή Δραστηριότητας' :
                    name === "BASICFORM" ? 'Βασικά Στοιχεία Αίτησης':
                    name === 'EXPENSESFORM' ? 'Δαπάνες Αίτησης':
                    name === "DOCUMENTS" ? 'Έγγραφα' : 
                    name === "TERMS" ? 'Όροι και Προϋποθέσεις' : 
                    name === "GRAPH" ? 'Συνοπτική Παρουσίαση Κατάστασης Αίτησης':
                    name === "INFO" ? 'Στοιχεία Αίτησης' :
                    name === "EVALUATIONFORM" ? 'Αξιολόγηση Αίτησης' :
                    getLocalString(locales, localNames.REQUEST_PAGE_HISTORICITY)}
                </div>
                {index === tabs.length - 1 ? '' : <div className="divider" />}
              </div>
            }
          >
            {isApptrack && 
            <Row>
              <Col span={12}>
                <ApplicationStatusOverview id={activeTask?.businessKey} activeTaskName={activeTask?.activeTaskName}/>
              </Col>
              <Col span={12}>
              {activeTab === 1 && <div className="tab2-icons" style={{display:"flex", justifyContent:"end", marginRight:'2rem', marginTop: '3.25rem'}}>
                  <Tooltip placement="left" title="Δείτε τα αναλυτικά στοιχεία της αίτησης">
                        <ViewTaskLink style={{cursor: 'pointer'}}
                          onClick={()=>onViewMode()}
                  /></Tooltip>
              </div>}
              </Col>
            </Row>}
            {!isApptrack && !subtabs &&
            <Row>
            <Col span={12}>
              <ApplicationStatusOverview id={businessKey} activeTaskName={activeTaskName}/>
            </Col>
          </Row>
            }
            <Component {...tabProps} />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default CustomTabsTimeline;
